const mapTypes = [
  { type: "map", three: "map", name: "Map" },
  { type: "normal_map", three: "normalMap", name: "Normal" },
  { type: "roughness_map", three: "roughnessMap", name: "Roughness" },
  { type: "metalness_map", three: "metalnessMap", name: "Metalness" },
  { type: "bump_map", three: "bumpMap", name: "Bump" },
  { type: "displacement_map", three: "displacementMap", name: "Displacement" },
  { type: "ao_map", three: "aoMap", name: "Ambient occlusion" }
];

const defaultMaterialData = {
  length: 100,
  width: 100,
  opacity: 1.0,
  bumpScale: 1.0,
  side: 0,
  blending: 1,
  transparent: false,
  roughness: 1.0,
  color: '#ffffff',
  emissiveColor: '#000000',
  emissiveIntensity: 1.0,
  thickness: 0.0,
  clearcoat: 0.0,
  clearcoatRoughness: 0.0,
  metalness: 0.0,
  normalScaleX: 1.0,
  normalScaleY: 1.0,
  reflectivity: 0.5,
  sheen: 0.0,
  sheenRoughness: 1.0,
  transmission: 0.0,
  aoMapIntensity: 1.0,
  displacementScale: 1.0,
  displacementBias: 0.0,
  flatShading: false,
  alphaTest: 0.0,
  depthTest: true,
  depthWrite: true,
};

export { mapTypes, defaultMaterialData };
